var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contactum-fields" }, [
    _c("div", { staticClass: "contactum-column-field-inner-columns" }, [
      _c(
        "ul",
        { staticClass: "contactum-column" },
        _vm._l(_vm.field.inner_fields, function(innerfield, index) {
          return _c(
            "li",
            { key: _vm.field.id },
            [
              innerfield.field_properties.required &&
              true === innerfield.field_properties.required
                ? _c("span", { staticClass: "required" }, [_vm._v(" *")])
                : _vm._e(),
              _vm._v(" "),
              _c("label", [
                _vm._v(_vm._s(innerfield.field_properties.title) + "  ")
              ]),
              _vm._v(" "),
              _c(innerfield.fields, {
                tag: "component",
                attrs: { field: innerfield.field_properties }
              })
            ],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", {
          staticClass: "help",
          domProps: { innerHTML: _vm._s(_vm.field.help) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }